import {Badge} from 'react-bootstrap'

const COLORS = {
  APPROVED: 'success',
  PENDING: 'warning',
  NOT_ASSIGNED: 'danger',
  CANCELED: 'secondary'
}

export const BadgeStatus = ({state}: {state: string}) => {
  return <Badge bg={COLORS[state]}>{state}</Badge>
}
